module.exports = __webpack_public_path__ + "static/media/Tomer.a66faf38.jpg";